import { SessionProvider } from 'next-auth/react';
import { ExperimentProps } from 'src/services/experiments/types';
import { ExperimentProvider } from 'src/providers/ExperimentProvider';
import { GraphqlProvider } from 'src/providers/GraphqlProvider';
import { PossibleZillowSession } from 'src/services/auth/types';
import { FunctionComponentWithChildren } from 'src/utils/types';
import { ZHLConditionalPageWrapper } from 'src/components/ZHLConditionalPageWrapper/ZHLConditionalPageWrapper';
import { isZillowURL } from 'src/utils/validators/isZillowURL';
import { isClientOriginOrPathZillow } from 'src/utils/validators/isClientOriginOrPathZillow';
import { MaybeString } from 'src/common/types';

export const UniversalWrappers: FunctionComponentWithChildren<
    {
        origin: string | undefined;
        session: PossibleZillowSession;
        requestURL: MaybeString;
    } & ExperimentProps
> = ({ session, origin, children, requestURL, ...rest }) => {
    // check both because origin is server side, but currentOrigin is client side
    const isOnZillow = isZillowURL(origin) || isZillowURL(requestURL) || isClientOriginOrPathZillow();
    return (
        <GraphqlProvider>
            <SessionProvider
                basePath={isOnZillow ? '/homeloans/mortgage/api/auth' : '/api/mortgage/auth'}
                refetchOnWindowFocus
                session={session}>
                <ExperimentProvider {...rest}>
                    <ZHLConditionalPageWrapper isZillowOrigin={isOnZillow}>{children}</ZHLConditionalPageWrapper>
                </ExperimentProvider>
            </SessionProvider>
        </GraphqlProvider>
    );
};
